import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Rating from "@mui/material/Rating";
import { ReactNode } from "react";

interface Iprops {
    feedbackData: any;
    renderDetails: (details: any) => ReactNode;
    renderChatDetails: (details: any) => ReactNode;
}

const ChatDetails = ({ feedbackData, renderDetails, renderChatDetails }: Iprops) => {
    return (
        <Accordion
            expanded
            disableGutters
            elevation={0}
            square
            sx={{
                marginTop: "15px",
                border: "1px solid #dbdce0",
                borderRadius: "8px",
                background: "rgba(32, 33, 36, 0.03)",
                "&::before": {
                    display: "none!important",
                },
                "& .MuiAccordionDetails-root": {
                    background: "#FFF",
                    borderRadius: "0 0 8px 8px",
                },
            }}
        >
            <AccordionSummary
                // expandIcon={<KeyboardArrowUpIcon />}
                aria-controls={"panel1-content"}
                id={"panel1-header"}
                sx={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: "14px",
                }}
            >
                <Grid
                    container
                    className="acc-prod-icon"
                    justifyContent="space-between"
                >
                    <Grid item spacing={2} className="acc-prod-icon">
                        Chat Details
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container mt="13px" rowGap="15px">
                    <Grid>
                        <Typography>
                            {feedbackData.feedbackComments &&
                                Object.keys(feedbackData.feedbackComments).length > 0 ? (
                                <>
                                    {" "}
                                    <Grid >
                                        {renderChatDetails(feedbackData.feedbackComments)}
                                    </Grid>
                                </>
                            ) : (
                                "-"
                            )}
                        </Typography>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default ChatDetails;
